module.exports = {
  RU: 'RU',
  UA: 'UA',
  EN: 'EN',
  ES: 'ES',
};
